import { render, staticRenderFns } from "./mima.vue?vue&type=template&id=1c16605b&scoped=true"
import script from "./mima.vue?vue&type=script&lang=js"
export * from "./mima.vue?vue&type=script&lang=js"
import style0 from "./mima.vue?vue&type=style&index=0&id=1c16605b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c16605b",
  null
  
)

export default component.exports